<div [style.padding]="'0px 0px'">
  <div #sliderContainer class="slider-container">
    <div *ngIf="isDesktop" class="slider" [style.transform]="'translateX(' + (-100 * currentIndex) + '%)'">
      <div class="slider-images">
        <ng-container *ngFor="let image of images">
          <img [ngStyle]="{
       'margin': '0 ' + marginDesk,
       'width': getWidth(marginDesk)
     }" [id]="image.id" (click)="redirect(image)" *ngIf="image?.path" [src]="apiUrl + image.path" alt="Image slider"
            class="slider-image" />
        </ng-container>
      </div>
    </div>

    <div *ngIf="!isDesktop" class="slider" [style.transform]="'translateX(' + (-100 * currentIndex) + 'vw)'">
      <div class="slider-images">
        <ng-container *ngFor="let image of images">
          <img [ngStyle]="{
       'margin': '0 ' + marginMob,
       'width': getWidth(marginMob)
     }" [id]="image.id" (click)="redirect(image)" *ngIf="image?.pathMobile" [src]="apiUrl + image.pathMobile"
            alt="Image slider" class="slider-image img-mob" />
        </ng-container>
      </div>
    </div>


    <!-- Bullets-->
    <div *ngIf="bullets.length > 1" class="bullets">
      <ng-container *ngFor="let b of bullets; index as i">
        <span class="bullet" [class.active]="bulletIndex === (i)" (click)="setPosition(i)"></span>
      </ng-container>
    </div>

  </div>

</div>